import React from "react"
import { Container, Row, Col } from "reactstrap"
import "./MykaV2Support.scss"

const MykaV2Support = ({ supportHeading, supportCards = [] }) => {
  return (
    <section className="myka-v2-support">
      <Container>
        {supportHeading && (
          <h2 className="myka-v2-support__heading">{supportHeading}</h2>
        )}

        <Row className="myka-v2-support__cards">
          {supportCards.map((card) => (
            <Col key={card.title} xs={12} lg={4} className="myka-v2-support__card-col">
              <div className="myka-v2-support__card">
                {card.icon?.sourceUrl && (
                  <div className="myka-v2-support__icon-wrap">
                    <img
                      src={card.icon.sourceUrl}
                      alt={card.iconAlt || ""}
                      className="myka-v2-support__icon"
                      loading="lazy"
                    />
                  </div>
                )}
                {card.title && (
                  <h3 className="myka-v2-support__card-title">{card.title}</h3>
                )}
                {card.body && (
                  <div
                    className="myka-v2-support__card-body"
                    dangerouslySetInnerHTML={{ __html: card.body }}
                  />
                )}
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default MykaV2Support
